import { render } from "./Mb066.vue?vue&type=template&id=32cec686&scoped=true"
import script from "./Mb066.vue?vue&type=script&lang=js"
export * from "./Mb066.vue?vue&type=script&lang=js"

import "./Mb066.vue?vue&type=style&index=0&id=32cec686&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cec686"]])

export default __exports__